import { render, staticRenderFns } from "./accidentRescue-item.vue?vue&type=template&id=0855613b&scoped=true"
import script from "./accidentRescue-item.vue?vue&type=script&lang=js"
export * from "./accidentRescue-item.vue?vue&type=script&lang=js"
import style0 from "./accidentRescue-item.vue?vue&type=style&index=0&id=0855613b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0855613b",
  null
  
)

export default component.exports